let idCounter = 0

export const generateUniqueId = () => {
  const timestamp = Date.now().toString(16)
  idCounter++
  return `${timestamp}${idCounter}`
}